/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InputGroup, FormControl, Button } from 'react-bootstrap';
import classNames from 'classnames';
import { map, isEmpty } from 'lodash';
import moment from 'moment';
import CacheSystem from '@utils/cacheSystem';

class SearchFieldCached extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchQuery : props.searchQuery,
			hasFocus    : false,
			history     : [],
			menuHover   : false,
		};
	}

	componentDidMount() {
		const { historyPrefix } = this.props;
		this._cacheSystem = new CacheSystem(historyPrefix, null);
		this.loadHistory();
	}

	// eslint-disable-next-line camelcase
	UNSAFE_componentWillReceiveProps = (newProps) => {
		const { searchQuery } = this.props;
		if (newProps.searchQuery !== searchQuery) this.setState({ searchQuery : newProps.searchQuery });
	}

	loadHistory = () => {
		const { historyPrefix } = this.props;
		let history = this._cacheSystem.getItemsByGroup(historyPrefix);

		// Sort items by createdDate if there are more than 1
		if (history.length > 1) history = history.sort(($0, $1) => (moment($0.content.created) < moment($1.content.created)));

		// Only select the first 5 items
		if (history.length > 5) history = history.slice(0, 5);

		this.setState({ history });
	}

	updateHistory = (searchQuery) => {
		const { historyPrefix : prefix } = this.props;
		if (searchQuery !== '') this._cacheSystem.set(`${prefix}:${searchQuery.toLowerCase().replace(/\s/g, '')}`, searchQuery, { group : prefix });

		this.loadHistory();
	}

	deleteHistoryItem = (uuid) => {
		this._searchField.focus();
		this._cacheSystem.deleteItemByUUID(uuid);
		this.loadHistory();
	}

	useHistoryItem = (searchQuery) => {
		this.setState({
			searchQuery,
			menuHover : false,
			hasFocus  : false,
		}, this.onSearch);
	}

	deleteAllHistory = (event) => {
		const { historyPrefix } = this.props;
		event.preventDefault();

		// Delete all the search items within the same group
		this._cacheSystem.deleteItemsByGroup(historyPrefix);
		this.loadHistory();
	}

	handleOnFieldChange = (event) => {
		this.setState({
			searchQuery : event.target.value,
		});
	}

	clearSearch = (event) => {
		const { onClear } = this.props;
		event.preventDefault();

		this.setState({
			searchQuery : '',
		}, onClear);
	}

	handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			// Blur searchField on press Enter
			this._searchField.blur();

			// Make sure the search result menu disappear on press Enter on searchField
			this.setState({ menuHover : false });

			// Execute search
			this.onSearch();
		}
	}

	onSearch = () => {
		const { searchQuery } = this.state;
		const { onSearch } = this.props;
		this.updateHistory(searchQuery);
		onSearch(searchQuery);
	}

	setMenuHover = (menuHover) => () => {
		this.setState({ menuHover });
	}

	render() {
		const { props } = this;
		const { state } = this;

		const recentSearches = map(state.history, (item) => (
			<li key={item.uuid}>
				<Button
					bsStyle="link"
					onClick={() => this.useHistoryItem(item.content.value)}
				>
					{item.content.value}
				</Button>
				<Button
					bsStyle="link"
					className="delete-result"
					onClick={() => this.deleteHistoryItem(item.uuid)}
				>
					<i className="rkf rkf-cross" />
				</Button>
			</li>
		));

		return (
			<div className="legacy">
				<div className="page-search-field">
					<InputGroup className="input-group-transparent">
						<InputGroup.Addon><i className="rkf rkf-search" /></InputGroup.Addon>
						<FormControl
							inputRef={(ref) => { this._searchField = ref; }}
							name="searchQuery"
							placeholder={props.placeholder}
							value={state.searchQuery}
							onChange={this.handleOnFieldChange}
							onKeyPress={this.handleKeyPress}
							onFocus={() => this.setState({ hasFocus : true })}
							onBlur={() => this.setState({ hasFocus : false })}
						/>
						<InputGroup.Button
							className={classNames('hideable', { 'hideable-hidden' : isEmpty(state.searchQuery) })}
						>
							<Button onClick={this.clearSearch}><i className="rkf rkf-cross" /></Button>
						</InputGroup.Button>
					</InputGroup>
					<div className={classNames('help-text hideable', { 'hideable-hidden' : !state.hasFocus })}>
						Press Enter to search
					</div>
					<div
						onMouseOver={this.setMenuHover(true)}
						onMouseOut={this.setMenuHover(false)}
						className={classNames('recent-searches-menu hideable', {
							'hideable-hidden' : !state.hasFocus && !state.menuHover,
						})}
					>
						<h6>
							Recent Searches
							<button
								type="button"
								onClick={this.deleteAllHistory}
								className={classNames('btn btn-link hideable', { 'hideable-hidden' : recentSearches.length === 0 })}
								aria-label="clear searches"
								onKeyPress={null}
								tabIndex={0}
							>
								Clear all
							</button>
						</h6>
						<ul className={classNames({ empty : recentSearches.length === 0 })}>
							{recentSearches}
							<If condition={recentSearches.length === 0}>
								<li>Nothing to display...</li>
							</If>
						</ul>
					</div>
				</div>
			</div>
		);
	}
}

SearchFieldCached.propTypes = {
	historyPrefix : PropTypes.string.isRequired,
	searchQuery   : PropTypes.string.isRequired,
	onSearch      : PropTypes.func.isRequired,
	onClear       : PropTypes.func.isRequired,
	placeholder   : PropTypes.string,
};

SearchFieldCached.defaultProps = {
	placeholder : 'Search',
};

export default SearchFieldCached;
